import React from "react";
import { DRAWING_COLORS } from "./frameGeometry";
import "./FrameAnnotations.css";

/**
 * Панель рисования поверх видео: цвета, отменить штрих, очистить, готово.
 * Показывается только в режиме рисования.
 */
const DrawingToolbar = ({ color, onColorChange, drawing, onChange, onDone, labels = {} }) => {
  const strokes = (drawing && drawing.strokes) || [];
  const undo = () => onChange(strokes.length <= 1 ? null : { v: 1, strokes: strokes.slice(0, -1) });
  const clear = () => onChange(null);

  return (
    <div className="fa-toolbar" onClick={(e) => e.stopPropagation()}>
      <div className="fa-toolbar-colors">
        {DRAWING_COLORS.map((c) => (
          <button
            key={c}
            type="button"
            className={`fa-color${c === color ? " active" : ""}`}
            style={{ background: c }}
            onClick={() => onColorChange(c)}
            title={c}
          />
        ))}
      </div>
      <div className="fa-toolbar-actions">
        <button type="button" className="fa-tool" onClick={undo} disabled={!strokes.length}>
          {labels.undo || "Отменить"}
        </button>
        <button type="button" className="fa-tool" onClick={clear} disabled={!strokes.length}>
          {labels.clear || "Очистить"}
        </button>
        <button type="button" className="fa-tool fa-tool--primary" onClick={onDone}>
          {labels.done || "Готово"}
        </button>
      </div>
    </div>
  );
};

export default DrawingToolbar;
